<template>
  <div class="checkList_box_wrap">
    <vxe-toolbar
      id="toolbarId_ca8"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter()" v-if="checkList_search_btn">
          查询
        </el-button>
        <el-button @click="funcExport()" v-if="checkListTotal_export">
          全部导出
        </el-button>
      </template>
    </vxe-toolbar>
    <!-- <div class="checkList_total">
      合计实付总金额:
      <span style="color:red;">{{ shipmentActualFreightTotal || "--" }}元</span>
    </div> -->
    <!-- table表格
      @sort-change="sortList"
      :footer-method="footerMethod"
      :loading="loading"
    -->
    <vxe-table
      :data="tableData"
      :loading="loading"
      ref="xTable"
      resizable
      stripe
      highlight-current-row
      border
      show-footer
      highlight-hover-row
      row-id="id"
      class="mytable-footer"
      height="90%"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      :footer-method="footerMethod"
    >
      <vxe-table-column type="checkbox" width="60" />
      <!-- 开票主体 -->
      <vxe-table-column>
        <vxe-table-column field="groupName" title="承运主体" min-width="300">
          <template #default="{row}">
            {{ row.groupName ? row.groupName : "/" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.groupName"
            placeholder="请输入承运主体"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="orderCode"
          title="运单单号"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.orderCode"
            placeholder="请输入运单号"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="createdByName"
          title="托运人"
          min-width="250"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.createdByName"
            placeholder="请输入托运人"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentDeliveryFeePractical"
          title="托运人应付运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.shipmentDeliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentDeliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="serviceFee"
          title="应付服务费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.serviceFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.serviceFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="deliveryFeePractical"
          title="实际承运人应净得运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.deliveryFeePracticalStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.deliveryFeePracticalEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 托运人已付运费 -->
      <vxe-table-column>
        <vxe-table-column
          field="shipmentActualFreight"
          title="托运人已付运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.shipmentActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 已付服务费 -->
      <vxe-table-column>
        <vxe-table-column
          field="actualServiceFee"
          title="已付服务费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.actualServiceFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.actualServiceFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 实际承运人已净得运费 -->
      <vxe-table-column>
        <vxe-table-column
          field="driverActualFreight"
          title="实际承运人已净得运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.driverActualFreightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.driverActualFreightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 未付运费 -->
      <vxe-table-column>
        <vxe-table-column
          field="noPayShipmentFee"
          title="未付运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.noPayShipmentFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.noPayShipmentFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 未付服务费 -->
      <vxe-table-column>
        <vxe-table-column
          field="noGetServiceFee"
          title="未付服务费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.noGetServiceFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.noGetServiceFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 实际承运人未得运费 -->
      <vxe-table-column>
        <vxe-table-column
          field="noGetDriverFee"
          title="实际承运人未得运费（元）"
          width="190"
          align="center"
        />
        <template v-slot:header>
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.noGetDriverFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.noGetDriverFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- 开票金额  -->
      <vxe-table-column>
        <vxe-table-column
          field="invoiceStatus"
          title="发票状态"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-select
            v-model="listQuery.invoiceStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in invoiceStatusList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </vxe-table-column>
      <!-- 开票时间 -->
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="invoiceIssuedTime"
          title="开票时间"
          width="300"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.invoiceIssuedTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
            @change="value => changeDate(value, 'invoiceIssuedTime')"
          />
        </template>
      </vxe-table-column>
      <!-- ETC(元) -->
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="totalAmountAll"
          title="ETC(元)"
          width="190"
        >
          <template #default="{row}">
            {{ row.totalAmountAll ? row.totalAmountAll : "/" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.taxPayFee"
            placeholder="请输入内容"
            clearable
          /> -->
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.totalAmountAllStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalAmountAllEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- ETC税额(元) -->
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="totalTaxAmountAll"
          title="ETC税额(元)"
          width="190"
        >
          <template #default="{row}">
            {{ row.totalTaxAmountAll ? row.totalTaxAmountAll : "/" }}
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.taxPayFee"
            placeholder="请输入内容"
            clearable
          /> -->
          <!-- <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.totalTaxAmountAllStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.totalTaxAmountAllEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row> -->
        </template>
      </vxe-table-column>
      <!-- TODO: -->
      <vxe-table-column>
        <vxe-table-column field="codeETC" title="ETC运单编号" min-width="300" />
        <!-- <template #default="{row}">
            <div v-if="row.etcInvoiceList && Array.isArray(row.etcInvoiceList)">
              <div>{{ row.etcInvoiceList[0].code }}</div>
            </div>
            <span v-else>/</span>
          </template>
        </vxe-table-column> -->
        <template v-slot:header>
          <el-input
            v-model="listQuery.codeETC"
            placeholder="请输入ETC运单编号"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- <vxe-table-column>
        <vxe-table-column
          field="invoiceNumber"
          title="ETC发票号码"
          min-width="300"
        />

        <template v-slot:header>
          <el-input
            v-model="listQuery.invoiceNumber"
            placeholder="请输入ETC发票号码"
            clearable
          />
        </template>
      </vxe-table-column> -->
      <vxe-table-column>
        <vxe-table-column
          field="invoiceNumExcel"
          title="ETC发票号码"
          min-width="300"
        >
          <template #default="{row}">
            <div v-if="row.etcInvoiceList && Array.isArray(row.etcInvoiceList)">
              <div v-for="(item, index) in row.etcInvoiceList" :key="index">
                {{ item.invoiceNum }};
              </div>
            </div>
            <span v-else>/</span>
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.invoiceNum"
            placeholder="请输入发票号码"
            clearable
          /> -->
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="coalTypeName"
          title="货物名称"
          width="140"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.coalTypeName"
            placeholder="请输入名称"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="weight"
          title="货物数量（吨）"
          align="center"
          width="190"
        />
        <template v-slot:header>
          <!-- <el-input
            v-model="listQuery.weight"
            placeholder="请输入内容"
            clearable
          /> -->
          <el-row>
            <el-col :span="11">
              <el-input
                style="padding-right:0px!important;"
                v-model="listQuery.weightStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.weightEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="loadPlace"
          title="装货地址"
          width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.loadPlace"
            placeholder="请输入地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          align="center"
          field="unloadPlace"
          title="卸货地址"
          width="200"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.unloadPlace"
            placeholder="请输入地址"
            clearable
          />
        </template>
      </vxe-table-column>
      <!-- ==================================================================================== -->
      <template v-if="false">
        <vxe-table-column>
          <vxe-table-column
            field="payStatus"
            align="center"
            title="支付状态"
            width="120"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.payStatus"
              placeholder="请选择"
              clearable
              @clear="clearPayStatus"
            >
              <el-option
                v-for="item in paymentStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <!-- 支付类型 -->
        <vxe-table-column>
          <vxe-table-column
            field="isPayAdvance"
            align="center"
            title="支付类型"
            width="120"
            :formatter="formatterPayType"
          />
          <template v-slot:header>
            <el-select
              v-model="listQuery.isPayAdvance"
              placeholder="请选择"
              clearable
              @clear="clearPayStatus"
            >
              <el-option
                v-for="item in preOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <!--payTimeStart/payTimeEnd  -->
        <vxe-table-column>
          <vxe-table-column
            field="payTime"
            title="支付时间"
            width="300"
            align="center"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.payTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- TODO: -->
        <vxe-table-column>
          <vxe-table-column
            field="invoiceStatus"
            align="center"
            title="开票状态"
            width="180"
          />

          <template v-slot:header>
            <el-select
              v-model="listQuery.invoiceStatus"
              placeholder="请选择开票状态"
              clearable
              @clear="clearInvoiceStatus"
            >
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
          <!-- <template #default="{ row }">{{ row }}</template> -->
        </vxe-table-column>
        <!-- TODO:时间 -->
        <vxe-table-column>
          <vxe-table-column
            align="center"
            field="invoiceIssuedTime"
            title="开票时间"
            width="300"
          />
          <template v-slot:header>
            <el-date-picker
              v-model="listQuery.invoiceIssuedTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- TODO: 预付、到付、回单付 -->
        <vxe-table-column>
          <vxe-table-column
            field="shipmentActualFreight"
            title="托运人应实付运费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.shipmentActualFreight"
            placeholder="请输入金额"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  style="padding-right:0px!important;"
                  v-model="listQuery.shipmentActualFreightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.shipmentActualFreightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- (实际承运人应净得运费（元）元) -->
        <vxe-table-column>
          <vxe-table-column
            field="driverActualFreight"
            title="实际承运人应净得运费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.driverActualFreight"
            placeholder="请输入内容"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  style="padding-right:0px!important;"
                  v-model="listQuery.driverActualFreightStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.driverActualFreightEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="taxPayFee"
            title="服务费（元）"
            width="190"
            align="center"
          />
          <template v-slot:header>
            <!-- <el-input
            v-model="listQuery.shipmentActualFreight"
            placeholder="请输入金额"
            clearable
          /> -->
            <el-row>
              <el-col :span="11">
                <el-input
                  style="padding-right:0px!important;"
                  v-model="listQuery.taxPayFeeStart"
                  type="number"
                  placeholder="下限"
                  clearable
                />
              </el-col>
              <el-col :span="11" :offset="2">
                <el-input
                  v-model="listQuery.taxPayFeeEnd"
                  type="number"
                  placeholder="上限"
                  clearable
                />
              </el-col>
            </el-row>
          </template>
        </vxe-table-column>
        <!-- new -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="payAmount"
          title="预付金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.payAmountStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.payAmountEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipperDeliveryFee"
          title="到付金额(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipperDeliveryFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipperDeliveryFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="shipmentActualCash"
          title="回单付款费(元)"
          min-width="200"
          sortable
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.shipmentActualCashStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.shipmentActualCashEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->

        <!-- <vxe-table-column>
        <vxe-table-column
          field="returnTaxFee"
          title="服务费(元)"
          min-width="200"
          sortable
          :formatter="formatterServicePAy"
        />
        <template v-slot:header>
          <el-row>
            <el-col :span="11">
              <el-input
                v-model="listQuery.returnTaxFeeStart"
                type="number"
                placeholder="下限"
                clearable
              />
            </el-col>
            <el-col :span="11" :offset="2">
              <el-input
                v-model="listQuery.returnTaxFeeEnd"
                type="number"
                placeholder="上限"
                clearable
              />
            </el-col>
          </el-row>
        </template>
      </vxe-table-column> -->
        <!--  -->

        <!-- 实际承运人姓名 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverName"
            title="实际承运人姓名"
            min-width="200"
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverName"
              placeholder="请输入实际承运人姓名"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- 实际承运人手机号 -->
        <vxe-table-column>
          <vxe-table-column
            field="driverPhone"
            title="实际承运人电话"
            min-width="200"
          />
          <template v-slot:header>
            <el-input
              v-model="listQuery.driverPhone"
              placeholder="请输入实际承运人电话"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- ETC运单编号 -->

        <!-- 发票单号 -->
        <vxe-table-column>
          <vxe-table-column
            field="invoiceCodeExcel"
            title="发票代码"
            min-width="300"
          >
            <template #default="{row}">
              <div
                v-if="row.etcInvoiceList && Array.isArray(row.etcInvoiceList)"
              >
                <div v-for="(item, index) in row.etcInvoiceList" :key="index">
                  {{ item.invoiceCode }};
                </div>
              </div>
              <span v-else>/</span>
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-input
              v-model="listQuery.invoiceCode"
              placeholder="请输入发票代码"
              clearable
            />
          </template>
        </vxe-table-column>
        <vxe-table-column>
          <vxe-table-column
            field="invoiceNumExcel"
            title="发票号码"
            min-width="300"
          >
            <template #default="{row}">
              <div
                v-if="row.etcInvoiceList && Array.isArray(row.etcInvoiceList)"
              >
                <div v-for="(item, index) in row.etcInvoiceList" :key="index">
                  {{ item.invoiceNum }};
                </div>
              </div>
              <span v-else>/</span>
            </template>
          </vxe-table-column>
          <template v-slot:header>
            <el-input
              v-model="listQuery.invoiceNum"
              placeholder="请输入发票号码"
              clearable
            />
          </template>
        </vxe-table-column>
        <!-- ETC开票日期   invoiceMakeTime 开票时间 -->
        <vxe-table-column>
          <vxe-table-column
            field="invoiceMakeTime"
            title="ETC开票日期"
            width="300"
            align="center"
          >
            <template #default="{row}">
              <div
                v-if="row.etcInvoiceList && Array.isArray(row.etcInvoiceList)"
              >
                <div v-for="(item, index) in row.etcInvoiceList" :key="index">
                  {{ item.invoiceMakeTime || "/" }};
                </div>
              </div>
              <span v-else>/</span>
            </template>
            <!-- <template #default="{row}">
            {{ row.invoiceMakeTime ? row.invoiceMakeTime : "/" }}
          </template> -->
          </vxe-table-column>
          <template v-slot:header>
            <!-- <el-date-picker
            v-model="listQuery.invoiceMakeTimeStart"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
          /> -->
          </template>
        </vxe-table-column>

        <!-- ETC状态，0是未推送，1/5是已推送，2是推送完成 -->
        <vxe-table-column v-if="false">
          <vxe-table-column
            field="etcType"
            title="ETC发票状态"
            width="120"
            align="center"
          >
            <template #default="{row}">{{ getEtcType(row.etcType) }}</template>
          </vxe-table-column>
          <template v-slot:header>
            <el-select
              v-model="listQuery.etcType"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in etcInvoiceStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column>
        <vxe-table-column
          align="center"
          field="etc"
          title="ETC发票金额(元)"
          width="100"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.etc"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="etcMain"
          align="center"
          title="ETC受票主体"
          width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.etcMain"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="etcMain"
          align="center"
          title="ETC交易数量"
          width="150"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.etcMain"
            placeholder="请输入内容"
            clearable
          />
        </template>
      </vxe-table-column> -->

        <!-- <vxe-table-column>
        <vxe-table-column
          field="etcInvoiceCount"
          title="ETC发票数量"
          width="150"
          align="center"
        >
          <template v-slot="{ row }">
            <span
              class="etc-invoice-count"
              @click="handleEtcInvoiceCount(row)"
              >{{ row.etcInvoiceCount }}</span
            >
          </template>
        </vxe-table-column>
        <template v-slot:header>
          <el-input
            v-model="listQuery.etcInvoiceCount"
            placeholder="请输入数量"
            clearable
          />
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          field="etcBatchTime"
          title="ETC推送时间"
          width="150"
          align="center"
        />
        <template v-slot:header>
          <el-date-picker
            v-model="listQuery.etcBatchTime"
            type="datetime"
            placeholder="请选择时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            clearable
          />
        </template>
      </vxe-table-column> -->
        <!-- <vxe-table-column>
        <vxe-table-column
          align="center"
          field="platformId"
          title="所属平台标识"
          width="160"
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.platformId"
            placeholder="请输入标识"
            clearable
          />
        </template>
      </vxe-table-column> -->

        <vxe-table-column v-if="false">
          <vxe-table-column
            field="proofPublishUrl"
            title="实际承运人付款凭证"
            width="120"
          />
          <!-- <template v-slot:header>
          <el-input
            v-model="listQuery.driverPaymentVoucher"
            placeholder="请输入内容"
            clearable
          />
        </template> -->
        </vxe-table-column>
        <vxe-table-column title="操作" width="120" v-if="false">
          <template v-slot="{ row }">
            <el-button type="text">预览</el-button>
            <el-button type="text">下载</el-button>
          </template>
        </vxe-table-column>
      </template>
    </vxe-table>
    <!-- 分页 -->
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-sizes="Pagingconf"
      :page-size.sync="listQuery.pageSize"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <!-- etc发票详情弹窗 -->
    <vxe-modal
      v-model="showDetail"
      title="ect发票详情"
      width="1070"
      height="600"
      resize
    >
      <checkDetail></checkDetail>
    </vxe-modal>
    <downloadData ref="downloadRef" />
  </div>
</template>

<script>
import { getLimit } from "@/utils/getLimit.js";
import checkDetail from "./components/checkDetail.vue";
import { settlementlistnew, settlementlistExport } from "@/api/category";

export default {
  components: {
    checkDetail
  },
  data() {
    return {
      invoiceStatusList: [
        { label: "申请开票", value: "0" },
        { label: "已开票", value: "1" },
        { label: "已取消", value: "2" },
        { label: "确认收票", value: "3" },
        { label: "开票中", value: "4" },
        { label: "开票失败", value: "5" },
        { label: "红冲中", value: "6" },
        { label: "已红冲", value: "7" },
        { label: "红冲待确认", value: "8" }
      ],
      shipmentActualFreightTotal: null,
      exportObj: {
        exportUrl: `/ntocc-tms-api/orderDetail/settlementlistnewExport`, //导出接口
        name: "结算清单总表",
        methods: true
      },
      checkList_export: false,
      checkList_search_btn: false,
      checkListTotal_export: false,
      listQuery: {
        groupName: "",
        orderCode: "",
        createdByName: "",
        shipmentDeliveryFeePracticalStart: "",
        shipmentDeliveryFeePracticalEnd: "",
        serviceFeeStart: "",
        serviceFeeEnd: "",
        deliveryFeePracticalStart: "",
        deliveryFeePracticalEnd: "",
        shipmentActualFreightStart: "",
        shipmentActualFreightEnd: "",
        actualServiceFeeStart: "",
        actualServiceFeeEnd: "",
        driverActualFreightStart: "",
        driverActualFreightEnd: "",
        noPayShipmentFeeStart: "",
        noPayShipmentFeeEnd: "",
        noGetServiceFeeStart: "",
        noGetServiceFeeEnd: "",
        noGetDriverFeeStart: "",
        noGetDriverFeeEnd: "",
        invoiceStatus: null,
        invoiceIssuedTimeStart: null,
        invoiceIssuedTimeEnd: null,
        codeETC: null,
        invoiceNumber: null,
        coalTypeName: null,
        weight: null,
        loadPlace: null,
        unloadPlace: null,
        total: 0
        //
        // orderCode: "",
        // createdByName: "",
        // payStatus: null,
        // payTime: "",
        // // shipmentActualFreight: "",
        // // taxPayFee: "",
        // // driverActualFreight: "",
        // etcType: "",
        // coalTypeName: "",
        // // weight: null,
        // weightStart: "",
        // weightEnd: "",
        // driverActualFreightStart: "",
        // driverActualFreightEnd: "",
        // taxPayFeeStart: "",
        // invoiceStatus: null,
        // taxPayFeeEnd: "",
        // shipmentActualFreightStart: "",
        // shipmentActualFreightEnd: "",
        // loadPlace: "",
        // unloadPlace: ""
      },
      paymentStatusOptions: [
        { value: "0", label: "处理中" },
        { value: "1", label: "已支付" },
        { value: "2", label: "支付失败" },
        { value: "99", label: "未支付" } //TODO:"99"处理不显示清除icon的问题
      ],
      preOptions: [
        { value: 0, label: "到付运费" },
        { value: 1, label: "预付运费" },
        { value: 2, label: "回单运费" }
      ],
      invoiceStatusOptions: [
        { value: "0", label: "申请开票" },
        { value: "1", label: "已开票" },
        { value: "2", label: "已取消" },
        { value: "99", label: "待申请" } //TODO:"99"处理不显示清除icon的问题
      ],
      etcInvoiceStatusOptions: [
        { value: "未开票", label: "未开票" },
        { value: "已开票", label: "已开票" }
      ],
      tableData: [],
      showDetail: false,
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.checkList_export = getLimit("checkList_export");
    this.checkList_search_btn = getLimit("checkList_search_btn");
    this.checkListTotal_export = getLimit("checkListTotal_export");
    this.findList();
  },
  mounted() {},
  methods: {
    formatterInvoiceStatus({ cellValue }) {
      const item = this.invoiceStatusList.find(
        item => item.value === cellValue
      );
      return item ? item.label : "";
    },
    formatterServicePAy(row) {
      console.log(row.row.isPayAdvance);
      if (row.row.isPayAdvance == 0) {
        return row.row.taxPayFee;
      } else if (row.row.isPayAdvance == 1) {
        return "--";
      } else if (row.row.isPayAdvance == 2) {
        return row.row.returnTaxFee;
      }
    },

    formatterPayType(row) {
      console.log("formatterPayType================", row);
      switch (row.row.isPayAdvance) {
        case 0:
          return "到付运费";
        case 1:
          return "预付运费";
        case 2:
          return "回单运费";
      }
    },
    async getSettlementlistExport() {
      let res = await settlementlistExport(this.listQuery);
      console.log("getSettlementlistExport===", res);
    },
    footerMethod({ columns, data }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) {
            return "合计";
          }
          if (column.property === "shipmentActualFreight") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "taxPayFee") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "totalAmountAll") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "totalTaxAmountAll") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "driverActualFreight") {
            return this.$XEUtils.sum(data, column.property);
          }
          if (column.property === "weight") {
            return this.$XEUtils.sum(data, column.property);
          }
          return "-";
        })
      ];
    },
    clearPayStatus() {
      this.listQuery.payStatus = null;
    },
    clearInvoiceStatus() {
      this.listQuery.invoiceStatus = null;
    },
    getInvoiceStatus(state) {
      switch (state) {
        case "0":
          return "申请开票";
        case "1":
          return "已开票";
        case "2":
          return "已取消";
        case "3":
          return "确认收票";
        case "4":
          return "开票中";
        case "5":
          return "开票失败";
        case "6":
          return "红冲中";
        case "7":
          return "已红冲";
        case "8":
          return "红冲待确认";
        default:
          return "未开票";
      }
    },
    getEtcType(type) {
      switch (type) {
        case "0":
          return "未推送";
        case "1":
          return "已推送";
        case "2":
          return "推送完成";
        case "5":
          return "分单已推送";
        default:
          return "--";
      }
    },
    getPayState(state) {
      switch (state) {
        case "0":
          return "处理中";
        case "1":
          return "已支付";
        case "2":
          return "支付失败";
        default:
          return "未支付";
      }
    },
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        // let data = { ...this.listQuery, weight: +this.listQuery.weight };
        // if (this.listQuery.payTime) {
        //   data.payTimeStart = this.listQuery.payTime[0];
        //   data.payTimeEnd = this.listQuery.payTime[1];
        //   delete data.payTime;
        // }
        // if (this.listQuery.invoiceIssuedTime) {
        //   data.invoiceIssuedTimeStart = this.listQuery.invoiceIssuedTime[0];
        //   data.invoiceIssuedTimeEnd = this.listQuery.invoiceIssuedTime[1];
        //   delete data.invoiceIssuedTime;
        // }
        // if (data.payStatus === "99") {
        //   data.payStatus = "";
        // }
        // if (data.invoiceStatus === "99") {
        //   data.invoiceStatus = "";
        // }
        let data = {
          ...this.listQuery
        };
        settlementlistnew(data).then(response => {
          this.loading = false;

          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;

          // this.shipmentActualFreightTotal =
          //   response.data.sumObject.shipmentActualFreight;
          this.tableData.forEach(item => {
            item.invoiceStatus = this.getInvoiceStatus(item.invoiceStatus);
            item.EtcYDcode = Array.isArray(item.etcInvoiceList)
              ? item.etcInvoiceList[0].code
              : "/";
            // item.invoiceCodeExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceCode).join(";")
            //   : "/";
            // console.log("item.invoiceCodeExcel", item.invoiceCodeExcel);
            // item.invoiceNumExcel = Array.isArray(item.etcInvoiceList)
            //   ? item.etcInvoiceList.map(item => item.invoiceNum).join(";\n")
            //   : "/";
            console.log("item.invoiceNumExcel", item.invoiceNumExcel);
          });

          this.sumObject = response.data.sumObject;
          resolve();
        });
      });
    },
    handleDetail(row) {
      // this.$refs.checkDetail.getData(row);
    },
    handleEtcInvoiceCount(row) {
      // 处理ETC发票数量点击事件
      this.showDetail = true;
      console.log("ETC发票数量点击:", row);
    }
  }
};
</script>
<style lang="scss">
.checkList_box_wrap {
  height: calc(100vh - 160px);
  padding: 15px;
  .vxe-pager.is--loading:after {
    background-color: transparent;
  }
  position: relative;
}
</style>
<style scoped>
.checkList_total {
  position: absolute;
  right: 124px;
  top: 25px;
  font-weight: bold;
}
/* 针对微信浏览器定制滚动条 */
::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar {
  -webkit-appearance: none; /* 禁用默认样式 */
  height: 12px !important; /* 设置滚动条高度（常驻显示） */
  background-color: #f1f1f1; /* 轨道背景色 */
}

::v-deep
  .vxe-table:not(.is--empty).show--foot.scroll--x
  .vxe-table--body-wrapper::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important; /* 滑块颜色 */
  border-radius: 5px !important; /* 滑块圆角 */
}
.etc-invoice-count {
  color: #409eff;
  cursor: pointer;
}
.pay_success {
  color: green;
  font-weight: bold;
}
</style>
